module.exports = __webpack_public_path__ + "static/img/topBg.980432a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/masterCenter/topBg.jpg
// module id = QnW0
// module chunks = 1